import _ from 'lodash'
import { deleteEntry } from 'shared-js/utils/array-utils'

export function cleanHours (settingsBlob) {
  cleanStoreShiftsPromiseTimes(settingsBlob.storeShifts, settingsBlob)
  cleanOverlappingSpecialHours(settingsBlob)
}

export function cleanStoreShiftsPromiseTimes (storeShifts, settingsBlob) {
  const shiftsIds = _.get(storeShifts, 'shifts', [])
    .map(it => it.id)
  const byDayParts = _.get(settingsBlob, 'promiseTimes.byDayPart', [])
  for (const byDayPart of byDayParts) {
    if (!shiftsIds.includes(byDayPart.storeShift)) {
      deleteEntry(byDayParts, it => it.storeShift === byDayPart.storeShift)
    }
  }
}

/**
 * Remove company/group special hour if group/location has one of its own with a different id.
 * (i.e. group.location already added said special hour and does not care about upstream version.)
 * @param {Object} settingsBlob
 */
export function cleanOverlappingSpecialHours (settingsBlob) {
  const specialHours = _.get(settingsBlob, 'specialHours')

  if (!specialHours) {
    return
  }

  const baddies = []
  const hours = specialHours.hours

  if (!hours || !Array.isArray(hours) || !hours.length) {
    return
  }

  hours.filter(hour => hour.$added)
    .forEach(hour => {
      baddies.push(...hours.filter(h => h.dateString === hour.dateString && h.id !== hour.id))
    })

  specialHours.hours = hours.filter(hour => !baddies.includes(hour))
}
